import { RowCrudStatus } from "../../common/types";
import { AiSearchAutoEval } from "../../../api/graphql";
import { LangStore } from "../../../store";

export type AiSearchAutoEvalValuesType = {
  id: string;
  displayId: string;
  version_: string;
  __status__: RowCrudStatus;
  evaluatedAt: Date | null;
};

export type AiSearchAutoEvalErrorsType = {
  evaluatedAt?: { message: string; fieldLabel: string };
};

export function AiSearchAutoEvalValuesInit(): AiSearchAutoEvalValuesType {
  return {
    id: "",
    displayId: "",
    version_: "",
    __status__: "empty",
    evaluatedAt: null,
  };
}

export type AiSearchAutoEvalType =
  | AiSearchAutoEval
  | AiSearchAutoEvalValuesType;

export function aiSearchAutoEvalDisplayId(
  source: Partial<AiSearchAutoEval>,
  _langStore: LangStore
) {
  return (
    (source.runId ?? _langStore.emptyStringSymbol) +
    (source.queryIndex?.toString() ?? _langStore.emptyStringSymbol)
  );
}

export function getAiSearchAutoEvalValues(
  source: AiSearchAutoEvalType,
  _langStore: LangStore,
  _duplicated: boolean = false
): AiSearchAutoEvalValuesType {
  const entityValues = AiSearchAutoEvalValuesInit();
  entityValues.id = source.id;
  entityValues.displayId =
    "__status__" in source
      ? source.displayId
      : aiSearchAutoEvalDisplayId(source, _langStore);
  entityValues.version_ = source.version_;
  entityValues.evaluatedAt = new Date(source.evaluatedAt);
  if (_duplicated) {
    entityValues.__status__ = "added";
  } else if ("__status__" in source) {
    entityValues.__status__ = source.__status__;
  }
  return entityValues;
}
